var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-apex-charts',{attrs:{"type":"line","height":"112px","options":_vm.PageViewChart.viewChart.chartOptions,"series":_vm.PageViewChart.viewChart.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }